import { useCallback, useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { QUERIES } from 'app/components/Table/core/constants';
import { ID } from 'app/components/Table/core/types';

import { mailTrackingResend } from 'app/modules/mail-history/core/requests';
import { MailHistoryFilterParams, Recipient } from 'app/modules/mail-history/core/types';
import { checkParamSynced, useGetQueryParams } from 'app/modules/query-state/hooks';

import isNil from 'lodash/isNil';

const useMailHistory = () => {
  const [isShow, setIsShow] = useState({
    content: false,
    recipient: false,
    filter: false,
  });
  const [data, setData] = useState<{
    title: string;
    content: string;
    recipient: Recipient[];
  }>({
    title: '',
    content: '',
    recipient: [],
  });

  const queryClient = useQueryClient();

  const { synced, curParams } = useGetQueryParams<MailHistoryFilterParams>();
  const isSynced = checkParamSynced(synced);

  useEffect(() => {
    if (isSynced) queryClient.invalidateQueries(QUERIES.MAIL_TRACKING_LIST);
  }, [isSynced, JSON.stringify(curParams)]);

  const { mutate: resendMailTrackingMutation, isLoading: isLoadingResend } = useMutation({
    mutationKey: ['mail-tracking-resend'],
    mutationFn: (id: ID) => mailTrackingResend(id),
    onSuccess: () => {
      queryClient.invalidateQueries(QUERIES.MAIL_TRACKING_LIST);
    },
  });

  const handleClickBodyTable = () => () => {};

  const handleCloseModal = () =>
    setIsShow({
      content: false,
      recipient: false,
      filter: false,
    });

  const handleResendMailTracking = useCallback(
    (id: ID) => () => {
      resendMailTrackingMutation(id);
    },
    [resendMailTrackingMutation],
  );

  const hasActiveFilters = Object.keys(curParams).some(
    (key) => ['organizationId', 'recipientType', 'type'].includes(key) && !isNil(curParams[key]),
  );

  const handleClickFilter = (type: 'on' | 'off') => {
    setIsShow({
      ...isShow,
      filter: type === 'on',
    });
  };

  return {
    data,
    isShow,
    setData,
    setIsShow,
    isLoadingResend,

    handleCloseModal,
    hasActiveFilters,
    handleClickFilter,
    handleClickBodyTable,
    handleResendMailTracking,
  };
};

export default useMailHistory;
